<template>
  <v-card
    raised
    class="mb-1"
    :class="{ 'red lighten-4': errorUpload }"
  >
    <v-row no-gutters>
      <v-col
        cols="6"
      >
        <!--<editor-fold desc="Uploading loader">-->
        <v-progress-circular
          v-if="uploading"
          :indeterminate="true"
          :size="50"
          :width="3"
          height="90px"
          :value="file.progress"
        />
        <!--</editor-fold>-->

        <!--<editor-fold desc="Blob thumbnail">-->
        <v-img
          v-else-if="file.blob ? file.blob : file.thumb"
          :src="file.blob ? file.blob : file.thumb"
          max-height="90px"
          @click.native.stop="toogleMainFile"
        >
          <v-icon
            v-if="file.response.main"
            color="green lighten-1"
            large
            class="mr-2 mb-2"
            style="float: right;"
          >
            check
          </v-icon>
        </v-img>
        <!--</editor-fold>-->
      </v-col>
      <v-col
        cols="10"
      >
        <v-row
          no-gutters
          class=""
        >
          <v-col cols="7">
            <v-text-field
              :value="label"
              :disabled="!canEdit || errorUpload || uploading"
              hide-details
              outlined
              label="File Label"
              :placeholder="file.response ? file.response.original_file : file.name"
              @change="value => label = value"
            />
          </v-col>
          <v-col cols="7">
            <v-select
              v-model="tag"
              :items="tags"
              :disabled="!canEdit || errorUpload || uploading"
              outlined
              hide-details
              label="File Tag"
              placeholder="N/A Tag"
            />
          </v-col>
          <v-col>
            <v-btn
              v-if="canEdit && canRemove"
              class="my-0 mr-1"
              small
              icon
              @click.native.stop="removeFile(file.id)"
            >
              <v-icon :color="errorUpload ? 'orange lighten-4' : 'red'">
                clear
              </v-icon>
            </v-btn>
            <v-btn
              v-if="uploaded"
              class="my-0 mr-1"
              small
              icon
              @click.native.stop="previewImage(file.response.path)"
            >
              <v-icon color="grey">
                open_with
              </v-icon>
            </v-btn>
            <v-btn
              v-if="canEdit && !uploading && errorUpload"
              class="my-0 mr-1"
              small
              icon
              @click.native.stop="retryUpload"
            >
              <v-icon color="orange lighten-4">
                autorenew
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'FileCard',
    props: {
      file: {
        type: Object,
        default: () => {}
      },
      canRemove: {
        type: Boolean,
        default: true
      },
      canEdit: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        tags: [
          {
            text: 'Layout',
            value: 'layout'
          },
          {
            text: 'Engine',
            value: 'engine'
          }
        ]
      }
    },
    computed: {
      uploading() {
        return this.file.active && parseInt(this.file.progress) < 100
      },
      uploaded() {
        return this.file.success && parseInt(this.file.progress) === 100 && this.file.response.id
      },
      errorUpload() {
        return !this.file.success && !this.file.active
      },
      error() {
        return this.file.error
      },
      label: {
        get: function () {
          return this.uploaded ? this.file.response.label : null
        },
        set: function (value) {
          this.updateFile({ fileId: this.file.id, data: { label: value } })
        }
      },
      tag: {
        get: function () {
          return this.uploaded ? this.file.response.tag : null
        },
        set: function (value) {
          this.updateFile({ fileId: this.file.id, data: { tag: value } })
        }
      },
      main: {
        get: function () {
          return this.uploaded ? this.file.response.main : null
        },
        set: function (value) {
          this.updateFile({ fileId: this.file.id, data: { main: value } })
        }
      }
    },
    methods: {
      ...mapActions(['previewImage', 'updateFile', 'removeFile', 'setMainFile', 'unsetMainFile']),
      retryUpload() {
        // todo: retry upload this file
        // this.$parent.$refs.upload.active = true
      },
      toogleMainFile() {
        if (this.file.response.main) {
          this.unsetMainFile()
        } else {
          this.setMainFile(this.file.id)
        }
      }
    }
  }
</script>
